import { queryAll, query, fromId } from '../utils/utils.js';

export class Hero {

    heroBlock = null;

    constructor() {

        this.checkForContactBlocks();
        this.checkHeroSize();
        this.checkForBreadcrubs();
    }

    checkForContactBlocks() {
        queryAll('.hero').forEach((hero) => {

            if (hero.querySelector('.contact-block')) {
                hero.classList.add('contact-block-true');
            } else {
                hero.classList.add('contact-block-false');
            }
        });
    }

    checkHeroSize() {
        queryAll('.hero').forEach((hero) => {
            const container = hero.querySelector('.container');
            if (container) {
                if( container.offsetHeight < 200 ) {
                    hero.classList.add('hero-short');
                }
            }
        });
    }

    checkForBreadcrubs() {
		try{
			query('.yoast-breadcrumbs') ? query('.hero')?.classList.add('breadcrumbs-true') : null;
		}catch(e){
			console.log(e);
		}
    }


}
